export const Theme = {
    colors: {
        primary: "#0f172a",
        light: "#131c31",
        secondary: "#7eadfc",
        white: "#fff",
        black: "#000",
        paraText: "#dcdcdc",
    },
    fonts: {
        family: "DM Sans",
        weight: {
            regular: 400,
            medium: 500,
            bold: 700,
        }
    },
    breakpoints: {
        mobile: "768px",
    }
}